import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-monthly-absence-report',
  templateUrl: './monthly-absence-report.component.html',
  styleUrls: ['./monthly-absence-report.component.scss']
})
export class MonthlyAbsenceReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
